import { Seo } from "@/components/site/Seo";
import { PageIntro } from "@/components/site/PageIntro";
import { useLang } from "@/i18n";
import { JsonLd } from "@/components/site/JsonLd";
import { profilePageSchema } from "@/data/structuredData";
import { AcademicProfile } from "@/components/about/AcademicProfile";

const Interests = ({ a }) => (
  <div className="mt-12 p-8 sm:p-10 bg-[#F8F6F0] border border-[#D3CEC4] rounded-2xl" data-testid="interests">
    <p className="text-[11px] tracking-[0.28em] uppercase font-semibold text-[#374F49]">{a.clinicalLabel}</p>
    {a.clinical.map((p, i) => (
      <p key={i} data-testid={`clinical-interests-${i}`} className="font-serif text-lg sm:text-xl mt-4 leading-relaxed text-[#1A2522]">{p}</p>
    ))}
    <div className="mt-6 pt-6 border-t border-[#D3CEC4]/80">
      <p className="text-[11px] tracking-[0.28em] uppercase font-semibold text-[#374F49]">{a.scientificLabel}</p>
      <p className="text-[13px] sm:text-base text-[#495854] mt-3 leading-relaxed">{a.scientific}</p>
    </div>
  </div>
);

export default function About() {
  const { lang, t } = useLang();
  const a = t.about;
  return (
    <>
      <Seo page="about" />
      <JsonLd data={profilePageSchema(lang)} />
      <PageIntro testId="about-intro" overline={a.overline} title={a.title} italic={a.italic} />
      <section data-testid="about-section" className="max-w-7xl mx-auto px-6 sm:px-12 pb-24 sm:pb-32 grid lg:grid-cols-12 gap-12 lg:gap-20">
        <div className="lg:col-span-5 self-start space-y-4">
          <figure className="mb-8" data-testid="about-portrait">
            <div className="overflow-hidden rounded-[28px] aspect-[4/5] bg-[#EAE5D9]">
              <img src="/images/about-portrait.webp" alt={t.home.portraitAlt} className="w-full h-full object-cover object-top" loading="eager" />
            </div>
            <figcaption className="mt-3 text-[11px] text-[#7A857F]">© fot. Karolina Fok-Jamróz / Archiwum SU</figcaption>
          </figure>
          {a.affiliations.map(([title, sub], i) => (
            <div key={title} className="border-l-2 border-[#374F49] pl-5 py-1" data-testid={`affiliation-${i}`}>
              <p className="font-serif text-lg text-[#1A2522]">{title}</p>
              <p className="text-sm text-[#495854] mt-0.5">{sub}</p>
            </div>
          ))}
        </div>
        <div className="lg:col-span-7">
          <p className="dropcap text-[#1A2522] leading-[1.75] text-[15px] sm:text-[16px] font-light" data-testid="bio-text">{a.bio[0]}</p>
          {a.bio.slice(1).map((p, i) => (
            <p key={i} className="mt-6 text-[#495854] leading-[1.85] text-[14px] sm:text-[15px] font-light" data-testid={`bio-paragraph-${i + 1}`}>{p}</p>
          ))}
          <Interests a={a} />
        </div>
      </section>
      <AcademicProfile a={a} />
    </>
  );
}
